<template>
    <v-sheet>
        <v-row class="pa-1" :dense="true">
            <v-col cols="6">
                <v-btn-toggle :divided="true" variant="outlined">
                    <v-btn @click="firstOperation">
                        <font-awesome-icon :icon="['fas', 'backward-step']" class="text-primary" />
                    </v-btn>

                    <v-btn @click="previousOperation">
                        <font-awesome-icon :icon="['fas', 'play']" class="text-primary fa-rotate-180" />
                    </v-btn>

                    <v-select v-model="form.OprSeq"
                              :items="operationSelection" variant="outlined" density="compact" color="primary" rounded="0" hide-details style="min-width: 10rem;"></v-select>

                    <v-btn @click="nextOperation">
                        <font-awesome-icon :icon="['fas', 'play']" class="text-primary" />
                    </v-btn>

                    <v-btn @click="lastOperation">
                        <font-awesome-icon :icon="['fas', 'forward-step']" class="text-primary" />
                    </v-btn>
                </v-btn-toggle>
            </v-col>
        </v-row>

        <v-row :dense="true">
            <v-col>
                <div class="section-heading font-weight-bold">
                    Subcontract Details
                </div>

                <v-row :dense="true">
                    <v-col class="d-flex align-center justify-end" cols="2">
                        Opr:
                    </v-col>

                    <v-col cols="2">
                        <v-text-field v-model="form.OpCode" :readonly="true" variant="outlined" density="compact" color="primary" hide-details></v-text-field>
                    </v-col>

                    <v-col class="d-flex align-center justify-end" cols="2">
                        Start Date:
                    </v-col>

                    <v-col cols="2">
                        <v-text-field :readonly="true" type="date" variant="outlined" density="compact" color="primary" hide-details></v-text-field>
                    </v-col>

                    <v-col class="d-flex align-center justify-end" cols="2">
                        Due Date:
                    </v-col>

                    <v-col cols="2">
                        <v-text-field :readonly="true" type="date" variant="outlined" density="compact" color="primary" hide-details></v-text-field>
                    </v-col>
                </v-row>

                <v-row :dense="true">
                    <v-col class="d-flex align-center justify-end" cols="2">
                        Operation:
                    </v-col>

                    <v-col cols="4">
                        <v-text-field :readonly="true" v-model="form.OpDesc" variant="outlined" density="compact" color="primary" hide-details></v-text-field>
                    </v-col>
                </v-row>

                <v-row :dense="true">
                    <v-col class="d-flex align-center justify-end" cols="2">
                        <v-btn :disabled="job?.JobClosed === '1' || !form.SubContract" color="close" @click="openSupplierSearchModal">Supplier ID...</v-btn>
                    </v-col>

                    <v-col cols="6">
                        <v-text-field v-model="form.VendorName" :readonly="true" @click="openSupplierSearchModal" variant="outlined" density="compact" color="primary" hide-details></v-text-field>
                    </v-col>
                </v-row>

                <v-row :dense="true">
                    <v-col class="d-flex align-center justify-end" cols="2">
                        Qty/Parent:
                    </v-col>

                    <v-col cols="4">
                        <v-text-field 
                            v-model="form.QtyPer" 
                            type="number" 
                            placeholder="0.00000000" 
                            variant="outlined" 
                            density="compact" 
                            color="primary" 
                            hide-details
                            :readonly="job?.JobClosed !== '0'" 
                            @focusout="QtyPerChange"
                            @keydown.enter="QtyPerChange"
                            @keydown.tab="QtyPerChange"
                        ></v-text-field>
                    </v-col>
                </v-row>

                <v-row :dense="true">
                    <v-col class="d-flex align-center justify-end" cols="2">
                        Run Qty:
                    </v-col>

                    <v-col cols="4">
                        <v-text-field v-model="form.RunQty" :readonly="true" type="number" placeholder="0.00" variant="outlined" density="compact" color="primary" hide-details></v-text-field>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>

        <v-divider class="my-3"></v-divider>

        <v-row :dense="true">
            <v-col>
                <div class="section-heading font-weight-bold">
                    Part Information
                </div>

                <v-row :dense="true">
                    <v-col class="d-flex align-center justify-end" cols="2">
                        <v-btn :disabled="true" color="close">Part...</v-btn>
                    </v-col>

                    <v-col cols="4">
                        <v-text-field 
                            v-model="form.PartNum" 
                            variant="outlined" 
                            density="compact" 
                            color="primary" 
                            hide-details
                            :readonly="true"
                        ></v-text-field>
                    </v-col>
                </v-row>

                <v-row :dense="true">
                    <v-col class="d-flex align-center justify-end" cols="2">
                        <v-btn :disabled="true" color="close">Description...</v-btn>
                    </v-col>

                    <v-col cols="6">
                        <v-text-field v-model="form.Description" :readonly="true" variant="outlined" density="compact" color="primary" hide-details></v-text-field>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </v-sheet>

    <v-dialog v-model="dialogs.supplierSearchModal">
        <SupplierSearch @supplierReceived="supplierReceived" />
    </v-dialog>
</template>

<script>
    import {useJobEntryStore} from "../../../../../../stores/ProjectManagement/JobEntry";
    import { mapWritableState } from "pinia";
    import SupplierSearch from "../../../../EngineeringWorkBench/MethodOfManufacturing/SupplierSearch.vue"
    import axios from "axios";

    export default {
        name: "SubcontractWindow",
        data() {
            return {
                form: {
                    OprSeq: null,
                    OpDesc: null,
                    QtyPer: null
                },
                dialogs: {
                    supplierSearchModal: false
                },
                runningProcesses: {
                    updatingSupplierChange: false,
                    updatingQtyPerChange: false
                }
            }
        },
        mounted() {
            this.parseData(this.currentOperation);
        },
        components: {
            SupplierSearch
        },
        computed: {
            ...mapWritableState(useJobEntryStore, [
                "currentAssembly",
                "currentOperation",
                "currentAssemblyOperations",
                "setCurrentOperation",
                "refreshAssemblies",
                "vendors",
                "job"
            ]), 
            operationSelection() {
                return this.currentAssemblyOperations.length
                    ? this.currentAssemblyOperations.map((operation) => {
                        return {
                            title: operation.OprSeq,
                            value: operation.OprSeq,
                        };
                    })
                    : [];
            }
        },
        watch: {
            currentOperation(value, oldValue) {
                this.parseData(value)
            }
        },
        methods: {
            openSupplierSearchModal() {
                if (this.job?.JobClosed === '0' && this.form.SubContract) {
                    this.dialogs.supplierSearchModal = true;
                }
            },
            supplierReceived(vendor) {
                this.form.VendorName = vendor.name
                this.handleSupplierChange(vendor.code)
                this.dialogs.supplierSearchModal = false;
            },
            async handleSupplierChange(vendorNum) {
                if (!this.runningProcesses.updatingSupplierChange) {
                    this.runningProcesses.updatingSupplierChange = true;

                    let params = {
                        type: 'VendorNum',
                        VendorNum: vendorNum
                    }

                    await this.sendUpdateCall(params);

                    this.runningProcesses.updatingSupplierChange = false;
                }
            },
            async QtyPerChange() {
                if (!this.runningProcesses.updatingQtyPerChange) {
                    this.runningProcesses.updatingQtyPerChange = true;

                    let params = {
                        type: 'QtyPer',
                        QtyPer: this.form.QtyPer
                    }

                    await this.sendUpdateCall(params);

                    this.runningProcesses.updatingQtyPerChange = false;
                }
            },
            async sendUpdateCall(additionalParams) {
                if (this.currentOperation && this.job.JobNum && this.job.JobClosed === '0') {
                    let params = {
                        OpCode: this.currentOperation?.OpCode,
                        OprSeq: this.currentOperation?.OprSeq,
                        AssemblySeq: this.currentOperation?.AssemblySeq,
                        JobNum: this.currentOperation.JobNum,
                    }
                    params = {...params, ...additionalParams}
        
                    await axios.post(route('api.epicor.jobs.opr.update'), params)
                        .then((response) => {
                            if (response.data.Status === 0) {
                                this.setErrorMessage(response.data.Message)
                            } else if (response.data.Status === 1) {
                                this.refreshAssemblies();
                            }
                        })
                        .catch((response) => {
                            console.log("Err: " + response)
                        })
                }
            },
            parseData(data) {
                if (data) {
                    this.form = data;
                }
            },
            nextOperation() {            
                if (this.currentAssemblyOperations.length < 2) { return; }

                let key = this.findCurrentKey();
                key += 1;
                if (key > this.currentAssemblyOperations.length - 1) {
                    key = 0;
                }
                this.setCurrentOperation(this.currentAssemblyOperations[key].OprSeq);
            },
            previousOperation() {
                if (this.currentAssemblyOperations.length < 2) { return; }

                let key = this.findCurrentKey();
                key -= 1;
                if (key < 0) {
                    key = this.currentAssemblyOperations.length - 1;
                }
                this.setCurrentOperation(this.currentAssemblyOperations[key].OprSeq);
            },
            firstOperation() {
                this.setCurrentOperation(this.currentAssemblyOperations[0].OprSeq);
            },
            lastOperation() {
                this.setCurrentOperation(this.currentAssemblyOperations[this.currentAssemblyOperations.length - 1].OprSeq);
            },
            findCurrentKey() {
                let i = 0;
                for (const mtl of this.currentAssemblyOperations) {
                    if (mtl.OprSeq === this.currentOperation.OprSeq) {
                        return i;
                    }
                    i += 1;
                }
            },
        }
    }
</script>

<style scoped>

</style>
